import React, { useEffect, useState } from 'react';
import {
  Input,
} from 'reactstrap';
import PropTypes from 'prop-types';

const CatalogGroupCheckbox = ({ checked, onChange }) => {
  const [isChecked, setIsChecked] = useState(checked);

  useEffect(() => {
    setIsChecked(checked);
  }, [checked]);

  const handleOnChange = (e) => {
    setIsChecked(e.target.checked);
    onChange(e);
  };

  return (
    <Input
      type="checkbox"
      checked={isChecked}
      onChange={handleOnChange}
    />
  );
};

CatalogGroupCheckbox.propTypes = {
  checked: PropTypes.bool,
  onChange: PropTypes.func
};

CatalogGroupCheckbox.defaultProps = {
  checked: false,
  onChange: Function.prototype
};

export default CatalogGroupCheckbox;
